<template>
  <div>
    <profile-form
      :create="create"
      :view="view"
      :change="change"
      @close="$router.push('/client/profile/list')"
      @list="$router.push('/client/profile/list')"
      @change="id=> $router.push('/client/profile/change?id=' + id)"
      @view="id=> $router.push('/client/profile/view?id=' + id)"
    />
  </div>
</template>
<script>

import ProfileForm from "@/views/admin/components/Profile-form.vue"

export default {
  components: { ProfileForm },
  props: ['create', 'change', 'view'],
  data: () => ({}),
}
</script>

<style scoped>

</style>
